exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1ktxKdpzbrsnqItIUpFf7E{position:relative;top:11vh}._2WpnWTpQgug0ZrBu88FBLI{display:flex;flex-direction:column;justify-content:center;align-items:center;height:70vh;width:100vw;font-size:30px}@media screen and (max-height: 455px){._1ktxKdpzbrsnqItIUpFf7E{top:50px}}@media screen and (min-height: 909px){._1ktxKdpzbrsnqItIUpFf7E{top:100px}}\n", ""]);
// Exports
exports.locals = {
	"routeDiv": "_1ktxKdpzbrsnqItIUpFf7E",
	"notFound": "_2WpnWTpQgug0ZrBu88FBLI"
};